module.exports = __webpack_public_path__ + "img/4.1.2d642027.png";